import logo from './images/logo.png';
import banner from './images/banner.jpeg';
import marker from './images/marker.svg';
import referImg from './images/refer-img.png';
import successImg from './images/success-img.png';
import zeroStateImg from 'Images/fallback_image.png';
import payBills from './images/pay-bills.png';

const themeImages = {
  logo: logo,
  banner: banner,
  marker: marker,
  product: logo,
  refer: referImg,
  success: successImg,
  zeroState: zeroStateImg,
  payBills,
};

export default themeImages;
